import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useIntl, FormattedMessage } from 'react-intl';
import { get } from '../../services/api';
import { usePageLoader } from '../../contexts/PageLoaderContext';
import { useNotifier } from '../../contexts/NotificationContext';

import Title from '../../components/common/Title/Title';
import Card from '../../components/common/Card/Card';
import * as FeIcons from 'react-icons/fi'; // Импортируем все иконки
import styles from './TemplateSelectionPage.module.css';
import {hideBackButton} from "../../services/telegramService";

const TemplateSelectionPage = () => {
    const [templates, setTemplates] = useState([]);
    const navigate = useNavigate();
    const intl = useIntl();
    const { showPageLoader, hidePageLoader } = usePageLoader();
    const { addNotification } = useNotifier();

    useEffect(() => {
        hideBackButton();
    }, []);

    useEffect(() => {
        showPageLoader();
        get('form-templates')
            .then(response => {
                if (response.data) {
                    setTemplates(response.data);
                }
            })
            .catch(error => addNotification(error.message, 'error'))
            .finally(() => hidePageLoader());
    }, [showPageLoader, hidePageLoader, addNotification]);

    const handleSelectTemplate = (template) => {
        // Передаем выбранный шаблон на страницу создания через state
        navigate('/create-form', { state: { template } });
    };

    const handleCreateBlank = () => {
        // Если создаем пустую, просто переходим без state
        navigate('/create-form');
    };

    return (
        <div>
            <Title><FormattedMessage id="templates.pageTitle" /></Title>

            <Card
                className={styles.templateCard}
                onClick={handleCreateBlank} // Переход на пустую форму
            >
                <FeIcons.FiPlusCircle className={styles.icon} />
                <div className={styles.textWrapper}>
                    <h3 className={styles.title}><FormattedMessage id="templates.blank" /></h3>
                    <p className={styles.description}><FormattedMessage id="templates.blank.desc" /></p>
                </div>
            </Card>

            <h2 className={styles.sectionTitle}><FormattedMessage id="templates.useTemplate" /></h2>
            <div className={styles.grid}>
                {templates.map(template => {
                    const Icon = FeIcons[template.icon] || FeIcons.FiFileText;
                    return (
                        <Card
                            key={template.id}
                            className={styles.templateCard}
                            onClick={() => handleSelectTemplate(template)}
                        >
                            <Icon className={styles.icon} />
                            <div className={styles.textWrapper}>
                                <h3 className={styles.title}>{template.title}</h3>
                                <p className={styles.description}>{template.description}</p>
                            </div>
                        </Card>
                    );
                })}
            </div>
        </div>
    );
};
export default TemplateSelectionPage;
